import { INCOMPLETE_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION } from 'constants/studentPortfolio';

export const INITIAL_FILTERS = {
  no_standards: false,
  status: INCOMPLETE_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION.value
};
